import { render, staticRenderFns } from "./applicationUsersApprovalForms.vue?vue&type=template&id=55bb468c&scoped=true"
import script from "./applicationUsersApprovalForms.vue?vue&type=script&lang=js"
export * from "./applicationUsersApprovalForms.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersApprovalForms.vue?vue&type=style&index=0&id=55bb468c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bb468c",
  null
  
)

export default component.exports